export function validateCandleTrail(candleDuration) {
  if (
    !candleDuration ||
    candleDuration <= 0 ||
    !Number.isInteger(candleDuration)
  )
    return [false, 'Candle duration must be a whole number larger than zero. '];

  return [true, ''];
}
